import React from 'react';
import { FaRegClock, FaMoneyBillWave, FaRocket } from "react-icons/fa";
import { BsStars } from "react-icons/bs";
import { MdOutlineOndemandVideo } from "react-icons/md";

const AIVideoPage = () => {
    return (
        <div className="pt-48 md:pt-56 pb-20 specialBg min-h-screen text-mainColor" dir="rtl">
            <div className="max-w-[1200px] mx-auto px-4">
                <div className="text-center mb-16">
                    <h1 data-aos="fade-down" className="font-bold text-4xl md:text-5xl lg:text-6xl gold-text mb-6">
                        סרטוני פרסומות לעסקים בבינה מלאכותית
                    </h1>
                    <h2 data-aos="fade-up" className="text-xl md:text-2xl lg:text-3xl text-white font-medium max-w-[900px] mx-auto leading-relaxed">
                        🚀 רוצה לשדרג את העסק שלך עם סרטון תדמית מקצועי – בלי הפקות מסובכות ובלי יום צילום? 🎥
                    </h2>
                </div>
                
                <div className="mb-16">
                    <div data-aos="fade-in" className="bg-black/40 backdrop-blur-md p-8 md:p-10 rounded-3xl border border-white/10 shadow-2xl mb-12">
                        <div className="flex items-center gap-4 mb-6">
                            <BsStars className="text-orange-500 text-4xl" />
                            <h2 className="text-3xl md:text-4xl font-bold gold-text">הפתרון שלנו</h2>
                        </div>
                        <p className="text-lg md:text-xl leading-relaxed">
                            הפקת סרטוני תדמית יכולה להיות יקרה ומורכבת – לוגיסטיקה, שחקנים, תאורה וצוות צילום. אבל יש דרך חכמה, קלה וחסכונית יותר:<br/><br/>
                            אנחנו יוצרים עבורך סרטון תדמית מותאם אישית באמצעות תוכנות עריכה מתקדמות ובינה מלאכותית – <b>ללא צורך בצילום פיזי!</b> כל התהליך מתבצע מהמחשב, ואתה מקבל תוצאה מקצועית שתשדרג את הנוכחות שלך ברשתות החברתיות.
                        </p>
                    </div>

                    <h2 data-aos="fade-up" className="text-3xl md:text-4xl font-bold text-center gold-text mb-8">מה זה חוסך לך?</h2>
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-16">
                        <div data-aos="fade-up" data-aos-delay="100" className="bg-gradient-to-tr from-bgColor to-bgColor1 p-8 rounded-2xl border border-bgPath hover:border-secondaryColor transition-all duration-300 shadow-xl group">
                            <FaRegClock className="text-5xl text-orange-500 mb-6 mx-auto group-hover:scale-110 transition-transform duration-300" />
                            <h3 className="text-2xl font-bold text-center mb-4 text-white">זמן</h3>
                            <p className="text-center text-gray-300 text-lg">בלי פגישות צילום, בלי ארגון לוקיישן ובלי עיכובים מיותרים.</p>
                        </div>
                        <div data-aos="fade-up" data-aos-delay="200" className="bg-gradient-to-tr from-bgColor to-bgColor1 p-8 rounded-2xl border border-bgPath hover:border-secondaryColor transition-all duration-300 shadow-xl group">
                            <FaMoneyBillWave className="text-5xl text-orange-500 mb-6 mx-auto group-hover:scale-110 transition-transform duration-300" />
                            <h3 className="text-2xl font-bold text-center mb-4 text-white">כסף</h3>
                            <p className="text-center text-gray-300 text-lg">בלי הוצאות כבדות על שחקנים, תאורה, צוותי צילום והפקה.</p>
                        </div>
                        <div data-aos="fade-up" data-aos-delay="300" className="bg-gradient-to-tr from-bgColor to-bgColor1 p-8 rounded-2xl border border-bgPath hover:border-secondaryColor transition-all duration-300 shadow-xl group">
                            <FaRocket className="text-5xl text-orange-500 mb-6 mx-auto group-hover:scale-110 transition-transform duration-300" />
                            <h3 className="text-2xl font-bold text-center mb-4 text-white">תוצאה מהירה</h3>
                            <p className="text-center text-gray-300 text-lg">קבלת סרטון מרשים ומוכן לפרסום תוך זמן קצר במיוחד.</p>
                        </div>
                    </div>

                    <div data-aos="zoom-in" className="bg-black/50 backdrop-blur-md p-8 md:p-12 rounded-3xl border border-white/10 shadow-2xl relative overflow-hidden">
                        <div className="absolute top-0 right-0 w-32 h-32 bg-orange-600/20 blur-3xl rounded-full"></div>
                        <div className="absolute bottom-0 left-0 w-32 h-32 bg-orange-600/20 blur-3xl rounded-full"></div>
                        <h2 className="text-3xl md:text-4xl font-bold text-center gold-text mb-8 relative z-10">איך זה עובד?</h2>
                        <div className="flex flex-col md:flex-row justify-center items-center gap-8 relative z-10">
                            <div className="flex-1 text-center">
                                <div className="w-16 h-16 bg-gradient-to-tr from-orange-600 to-orange-400 rounded-full flex items-center justify-center text-2xl font-bold text-black mx-auto mb-4">1</div>
                                <h3 className="text-xl font-bold text-white mb-2">אפיון מדויק</h3>
                                <p className="text-gray-300">שיחה קצרה להבנת הצרכים והמסר שלך</p>
                            </div>
                            <div className="hidden md:block w-16 h-1 bg-gradient-to-l from-orange-600 to-transparent"></div>
                            <div className="flex-1 text-center">
                                <div className="w-16 h-16 bg-gradient-to-tr from-orange-600 to-orange-400 rounded-full flex items-center justify-center text-2xl font-bold text-black mx-auto mb-4">2</div>
                                <h3 className="text-xl font-bold text-white mb-2">יצירת הקסם</h3>
                                <p className="text-gray-300">הפקת סרטון מרשים שתופס את העין</p>
                            </div>
                            <div className="hidden md:block w-16 h-1 bg-gradient-to-l from-orange-600 to-transparent"></div>
                            <div className="flex-1 text-center">
                                <div className="w-16 h-16 bg-gradient-to-tr from-orange-600 to-orange-400 rounded-full flex items-center justify-center text-2xl font-bold text-black mx-auto mb-4">3</div>
                                <h3 className="text-xl font-bold text-white mb-2">חשיפה ולקוחות</h3>
                                <p className="text-gray-300">העסק שלך מקבל חשיפה מקצועית – בלי כאבי ראש!</p>
                            </div>
                        </div>
                        
                        <div className="text-center mt-12 relative z-10">
                            <h3 className="font-bold text-2xl md:text-3xl text-white mb-4">💬 מוכן לפרסם חכם יותר?</h3>
                            <p className="text-xl text-orange-500">אנחנו כאן כדי להפוך את הרעיון שלך לסרטון מנצח!</p>
                        </div>
                    </div>
                </div>

                <div className="flex items-center justify-center gap-4 mb-10">
                    <MdOutlineOndemandVideo className="text-4xl text-orange-500" />
                    <h2 data-aos="fade-up" className="font-bold text-3xl md:text-5xl text-center gold-text">
                        דוגמאות לסרטונים שלנו
                    </h2>
                </div>
                
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                    {[
                        "xk2BizqfDPY",
                        "3QYNMRcWHfk",
                        "vBclR6HqeL0",
                        "7VCBrkhj2lw",
                        "6qn5hOwcr0k",
                        "7yNS51UNwdY",
                        "Q1CzuHXSwfA",
                        "A9d3bAcTtvc",
                        "RU7itAc28a8"
                    ].map((videoId, index) => (
                        <div key={index} data-aos="zoom-in" data-aos-delay={(index % 3) * 100} className="w-full aspect-video group">
                            <div className="w-full h-full p-1 rounded-2xl bg-gradient-to-tr from-white/5 to-white/20 group-hover:from-orange-600/50 group-hover:to-orange-400/50 transition-all duration-500">
                                <iframe 
                                    className="w-full h-full rounded-xl shadow-xl bg-black"
                                    src={`https://www.youtube.com/embed/${videoId}`} 
                                    title={`YouTube video player ${index}`} 
                                    frameBorder="0" 
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                                    allowFullScreen>
                                </iframe>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default AIVideoPage;
